import React from "react";
import { FieldInputProps, FieldMetaProps, FastField, Field } from "formik";
import colors from "../../constants/colors";
import { InputOptions } from "./InputOptions";
import { FormikInputProps } from "./FormikInputProps";

import { FormControl, FormLabel, TextField, MenuItem } from "@material-ui/core";

const styles = {
	formControl: {
		marginRight: 16,
		marginBottom: 24,
	},
	formControlLabel: {
		fontSize: ".75rem",
		margin: 0,
		textTransform: "uppercase" as any,
		color: colors.gray600,
	},
	inputField: {
		marginTop: 8,
	},
};

export const FormikTextInput = (props: FormikInputProps) => {
	const createFormikProps = (name: string, changeHandler: null | ((e: React.ChangeEvent<any>) => void) = null) => {
		return {
			id: name,
			name: name,
			value: props.field.value || "",
			onChange:
				changeHandler === null
					? props.field.onChange
					: (e: React.ChangeEvent<any>) => {
							changeHandler(e);
							props.field.onChange(e);
						},
			onBlur: props.field.onBlur,
			error: props.meta.touched && Boolean(props.meta.error),
			helperText: props.meta.touched ? props.meta.error : "",
			autoComplete: "off",
		};
	};

	const attrs: any = {
		select: !!props.options.isSelect,
		disabled: !!props.options.disabled,
		multiline: !!props.options.isTextArea,
	};

	if (props.options.isDate) {
		attrs.type = "datetime-local";
	}

	const inputWidth = props.options.inputWidth || 300;
	const formControlWidth = props.options.formControlWidth || "auto";

	return (
		<FormControl style={{ ...styles.formControl, width: formControlWidth }}>
			<FormLabel style={styles.formControlLabel}>{props.options.label}</FormLabel>
			<TextField
				{...attrs}
				{...createFormikProps(props.field.name, props.options.changeHandler)}
				style={{ ...styles.inputField, width: inputWidth }}
			>
				{!!props.options.isSelect && !!props.options.appendEmptySelectOption && <MenuItem value="">None</MenuItem>}

				{!!props.options.isSelect &&
					(props.options.selectOptions || []).map(({ val, text }) => (
						<MenuItem key={val} value={val}>
							{text}
						</MenuItem>
					))}
			</TextField>
		</FormControl>
	);
};

export const renderFormikTextInput =
	(options: InputOptions) =>
	({ field, meta }: { field: FieldInputProps<any>; meta: FieldMetaProps<any> }) => (
		<FormikTextInput field={field} meta={meta} options={options} />
	);

const OptimizedFormikTextInputField = (options: InputOptions) => (
	<>
		{options.optimized ? (
			<FastField name={options.name}>{renderFormikTextInput(options)}</FastField>
		) : (
			<Field name={options.name}>{renderFormikTextInput(options)}</Field>
		)}
	</>
);

export const FormikTextInputField = React.memo(OptimizedFormikTextInputField);
